(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('collection-list-carousel')) {
    customElements.define('collection-list-carousel', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-carousel-viewport]');
        this.track = this.querySelector('[data-carousel-track]');
        this.items = Array.from(this.querySelectorAll('[data-carousel-item]'));
        this.controls = this.querySelector('[data-carousel-controls]');
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.viewport || !this.track) return;

        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);
        this.onScroll = () => this.updateControls();
        this.onResize = () => this.updateControls();
        this.onBlockSelect = (event) => event.target.closest?.('[data-carousel-item]')?.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });

        this.previous?.addEventListener('click', this.onPrevious);
        this.next?.addEventListener('click', this.onNext);
        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);

        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        const designMode = Boolean(window.Shopify && Shopify.designMode);
        if (this.dataset.reveal !== 'true' || reduceMotion || designMode || !('IntersectionObserver' in window)) {
          this.classList.add('is-visible');
        } else {
          this.revealObserver = new IntersectionObserver((entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.classList.add('is-visible');
            this.revealObserver.disconnect();
          }, { threshold: .12, rootMargin: '0px 0px -10% 0px' });
          this.revealObserver.observe(this);
        }

        requestAnimationFrame(() => this.updateControls());
      }

      disconnectedCallback() {
        this.previous?.removeEventListener('click', this.onPrevious);
        this.next?.removeEventListener('click', this.onNext);
        this.viewport?.removeEventListener('scroll', this.onScroll);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.resizeObserver?.disconnect();
        this.revealObserver?.disconnect();
      }

      move(direction) {
        const item = this.items[0];
        if (!item) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap || getComputedStyle(this.track).gap || 0);
        const logicalDirection = getComputedStyle(this).direction === 'rtl' ? -direction : direction;
        this.viewport.scrollBy({ left: logicalDirection * (item.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateControls() {
        if (!this.controls || !this.previous || !this.next) return;
        const scrollable = this.viewport.scrollWidth > this.viewport.clientWidth + 2;
        this.controls.hidden = !scrollable;
        if (!scrollable) return;

        const rtl = getComputedStyle(this).direction === 'rtl';
        const position = Math.abs(this.viewport.scrollLeft);
        const maximum = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.previous.disabled = position <= 2;
        this.next.disabled = position >= maximum - 2;
        if (rtl) {
          this.previous.disabled = position >= maximum - 2;
          this.next.disabled = position <= 2;
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collection-slider')) {
    customElements.define('featured-collection-slider', class FeaturedCollectionSlider extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-viewport]');
        this.items = Array.from(this.querySelectorAll('[data-item]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.progress = this.querySelector('[data-progress]');
        this.status = this.querySelector('[data-status]');
        if (!this.viewport || this.items.length === 0) return;

        this.onScroll = this.update.bind(this);
        this.onResize = this.update.bind(this);
        this.onPrevious = () => this.move(-1);
        this.onNext = () => this.move(1);

        this.viewport.addEventListener('scroll', this.onScroll, { passive: true });
        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.resizeObserver = new ResizeObserver(this.onResize);
        this.resizeObserver.observe(this.viewport);
        this.update();
      }

      disconnectedCallback() {
        this.viewport?.removeEventListener('scroll', this.onScroll);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.resizeObserver?.disconnect();
      }

      isEnabled() {
        return window.matchMedia('(min-width: 990px)').matches
          ? this.dataset.desktopCarousel === 'true'
          : this.dataset.mobileSwipe === 'true';
      }

      update() {
        if (!this.viewport) return;
        this.style.setProperty('--featured-collection-viewport-width', `${this.viewport.clientWidth}px`);
        const maximum = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth);
        const position = Math.min(maximum, Math.abs(this.viewport.scrollLeft));
        const enabled = this.isEnabled() && maximum > 4;
        this.toggleAttribute('data-overflow', enabled);
        if (this.previousButton) this.previousButton.disabled = !enabled || position <= 2;
        if (this.nextButton) this.nextButton.disabled = !enabled || position >= maximum - 2;
        const progress = maximum > 0 ? position / maximum : 0;
        this.style.setProperty('--featured-collection-progress', progress.toFixed(4));

        if (this.status) {
          const firstItem = this.items[0];
          const listStyle = getComputedStyle(this.querySelector('[data-list]'));
          const gap = parseFloat(listStyle.columnGap || listStyle.gap) || 0;
          const step = firstItem ? firstItem.getBoundingClientRect().width + gap : 1;
          const current = Math.min(this.items.length, Math.round(position / step) + 1);
          this.status.textContent = `${current} / ${this.items.length}`;
        }
      }

      move(direction) {
        if (!this.isEnabled()) return;
        const first = this.items[0];
        if (!first) return;
        const listStyle = getComputedStyle(this.querySelector('[data-list]'));
        const gap = parseFloat(listStyle.columnGap || listStyle.gap) || 0;
        const rtlDirection = document.documentElement.dir === 'rtl' ? -1 : 1;
        this.viewport.scrollBy({ left: direction * rtlDirection * (first.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('featured-collections-tabs')) {
    customElements.define('featured-collections-tabs', class FeaturedCollectionsTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-panel]'));
        if (this.tabs.length === 0 || this.panels.length === 0) return;

        this.controls = this.querySelector('[data-controls]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');

        this.onClick = this.handleClick.bind(this);
        this.onKeydown = this.handleKeydown.bind(this);
        this.onEditorSelect = this.handleEditorSelect.bind(this);
        this.onResize = this.updateAll.bind(this);
        this.addEventListener('click', this.onClick);
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('shopify:block:select', this.onEditorSelect);

        this.panels.forEach((panel) => {
          const viewport = panel.querySelector('[data-viewport]');
          if (!viewport) return;
          viewport.scrollLeft = 0;
          viewport.addEventListener('scroll', () => this.updatePanel(panel), { passive: true });
        });

        this.resizeObserver = new ResizeObserver(this.onResize);
        this.panels.forEach((panel) => {
          const viewport = panel.querySelector('[data-viewport]');
          if (viewport) this.resizeObserver.observe(viewport);
        });
        this.updateAll();
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onClick);
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('shopify:block:select', this.onEditorSelect);
        this.resizeObserver?.disconnect();
      }

      handleClick(event) {
        const tab = event.target.closest('[data-tab]');
        if (tab && this.contains(tab)) {
          this.activate(this.tabs.indexOf(tab), true);
          return;
        }

        const button = event.target.closest('[data-previous], [data-next]');
        if (!button || !this.contains(button)) return;
        this.move(this.activePanel, button.hasAttribute('data-next') ? 1 : -1);
      }

      handleKeydown(event) {
        const tab = event.target.closest('[data-tab]');
        if (!tab) return;
        const current = this.tabs.indexOf(tab);
        let target = current;
        if (event.key === 'ArrowRight') target = (current + 1) % this.tabs.length;
        if (event.key === 'ArrowLeft') target = (current - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'Home') target = 0;
        if (event.key === 'End') target = this.tabs.length - 1;
        if (target === current) return;
        event.preventDefault();
        this.activate(target, true);
      }

      handleEditorSelect(event) {
        const blockId = event.detail?.blockId;
        const index = this.tabs.findIndex((tab) => tab.dataset.blockId === blockId);
        if (index >= 0) this.activate(index, false);
      }

      activate(index, focusTab) {
        if (index < 0 || index >= this.tabs.length) return;
        const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.tabs.forEach((tab, tabIndex) => {
          const selected = tabIndex === index;
          tab.setAttribute('aria-selected', selected ? 'true' : 'false');
          tab.tabIndex = selected ? 0 : -1;
          this.panels[tabIndex].hidden = !selected;
        });

        const selectedTab = this.tabs[index];
        const selectedPanel = this.panels[index];
        this.activePanel = selectedPanel;
        const selectedViewport = selectedPanel.querySelector('[data-viewport]');
        if (selectedViewport) {
          selectedViewport.scrollTo({ left: 0, behavior: 'auto' });
          this.previousButton?.setAttribute('aria-controls', selectedViewport.id);
          this.nextButton?.setAttribute('aria-controls', selectedViewport.id);
        }
        selectedTab.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'nearest' });
        if (focusTab) selectedTab.focus({ preventScroll: true });
        if (!reduceMotion && selectedPanel.animate) {
          selectedPanel.animate(
            [{ opacity: 0, transform: 'translateY(10px)' }, { opacity: 1, transform: 'translateY(0)' }],
            { duration: 220, easing: 'cubic-bezier(.22, 1, .36, 1)' }
          );
        }
        requestAnimationFrame(() => this.updatePanel(selectedPanel));
      }

      isCarouselEnabled() {
        return window.matchMedia('(min-width: 990px)').matches
          ? this.dataset.desktopCarousel === 'true'
          : this.dataset.mobileSwipe === 'true';
      }

      move(panel, direction) {
        if (!panel || !this.isCarouselEnabled()) return;
        const viewport = panel.querySelector('[data-viewport]');
        const firstItem = panel.querySelector('[data-item]');
        const list = panel.querySelector('[data-list]');
        if (!viewport || !firstItem || !list) return;
        const styles = getComputedStyle(list);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const directionFactor = document.documentElement.dir === 'rtl' ? -1 : 1;
        viewport.scrollBy({ left: direction * directionFactor * (firstItem.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      updateAll() {
        this.panels.forEach((panel) => {
          const viewport = panel.querySelector('[data-viewport]');
          if (viewport) panel.style.setProperty('--featured-collections-viewport-width', `${viewport.clientWidth}px`);
        });
        this.activePanel = this.panels.find((panel) => !panel.hidden) || this.panels[0];
        this.updatePanel(this.activePanel);
      }

      updatePanel(panel) {
        const viewport = panel.querySelector('[data-viewport]');
        const list = panel.querySelector('[data-list]');
        const items = Array.from(panel.querySelectorAll('[data-item]'));
        if (!viewport || !list || items.length === 0) return;

        panel.style.setProperty('--featured-collections-viewport-width', `${viewport.clientWidth}px`);
        const maximum = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const position = Math.min(maximum, Math.abs(viewport.scrollLeft));
        const enabled = this.isCarouselEnabled() && maximum > 4;
        this.toggleAttribute('data-overflow', enabled);

        if (this.previousButton) this.previousButton.disabled = !enabled || position <= 2;
        if (this.nextButton) this.nextButton.disabled = !enabled || position >= maximum - 2;

        const progress = maximum > 0 ? position / maximum : 0;
        this.style.setProperty('--panel-progress', progress.toFixed(4));
        const styles = getComputedStyle(list);
        const gap = parseFloat(styles.columnGap || styles.gap) || 0;
        const step = items[0].getBoundingClientRect().width + gap;
        const current = Math.min(items.length, Math.round(position / Math.max(step, 1)) + 1);
        if (this.status) this.status.textContent = `${current} / ${items.length}`;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["logo-list"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ekko-logo-list')) {
    customElements.define('ekko-logo-list', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('[data-logo-viewport]');
        this.track = this.querySelector('[data-logo-track]');
        this.group = this.querySelector('[data-logo-group]');
        this.previousButton = this.querySelector('[data-logo-previous]');
        this.nextButton = this.querySelector('[data-logo-next]');
        if (!this.viewport || !this.track || !this.group) return;

        this.updateBound = this.scheduleUpdate.bind(this);
        this.scrollBound = this.updateButtons.bind(this);
        this.previousBound = () => this.move(-1);
        this.nextBound = () => this.move(1);
        this.blockSelectBound = this.onBlockSelect.bind(this);
        this.pointerDownBound = this.pauseForTouch.bind(this);

        this.previousButton?.addEventListener('click', this.previousBound);
        this.nextButton?.addEventListener('click', this.nextBound);
        this.viewport.addEventListener('scroll', this.scrollBound, { passive: true });
        this.addEventListener('shopify:block:select', this.blockSelectBound);
        this.addEventListener('pointerdown', this.pointerDownBound, { passive: true });
        window.addEventListener('resize', this.updateBound, { passive: true });

        this.resizeObserver = new ResizeObserver(this.updateBound);
        this.resizeObserver.observe(this.viewport);
        this.scheduleUpdate();
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.updateFrame);
        clearTimeout(this.touchTimer);
        this.resizeObserver?.disconnect();
        this.previousButton?.removeEventListener('click', this.previousBound);
        this.nextButton?.removeEventListener('click', this.nextBound);
        this.viewport?.removeEventListener('scroll', this.scrollBound);
        this.removeEventListener('shopify:block:select', this.blockSelectBound);
        this.removeEventListener('pointerdown', this.pointerDownBound);
        window.removeEventListener('resize', this.updateBound);
      }

      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => this.update());
      }

      update() {
        const desktop = window.matchMedia('(min-width: 750px)').matches;
        let mode;
        if (desktop) {
          mode = this.dataset.desktopLayout === 'stacked' ? 'stacked' : this.dataset.desktopOverflow;
        } else {
          mode = this.dataset.mobileLayout;
        }

        this.cleanupRuntimeCopies();
        this.viewport.dataset.mode = mode;
        const gap = parseFloat(getComputedStyle(this.group).gap) || 0;
        let itemWidth;
        if (desktop) {
          const visible = Math.max(1, Number(this.dataset.desktopVisible) || 5);
          itemWidth = (this.viewport.clientWidth - gap * (visible - 1)) / visible;
        } else {
          const widthPercent = Math.max(20, Number(this.dataset.mobileItemWidth) || 44);
          itemWidth = this.viewport.clientWidth * widthPercent / 100;
        }
        this.style.setProperty('--ekko-logo-item-width', `${Math.max(1, itemWidth)}px`);

        const originals = Array.from(this.group.children);
        originals.forEach((item, index) => {
          item.hidden = mode === 'clipped' && desktop && index >= Number(this.dataset.desktopVisible);
        });

        if (mode === 'marquee') {
          this.prepareMarquee();
        } else {
          this.viewport.removeAttribute('data-ready');
          this.track.style.removeProperty('--ekko-logo-loop-distance');
          this.track.style.removeProperty('--ekko-logo-marquee-duration');
        }

        this.updateButtons();
      }

      cleanupRuntimeCopies() {
        this.querySelectorAll('[data-logo-runtime-copy]').forEach((copy) => copy.remove());
        Array.from(this.group?.children || []).forEach((item) => { item.hidden = false; });
      }

      prepareMarquee() {
        const sourceItems = Array.from(this.group.children);
        if (!sourceItems.length) return;

        let passes = 0;
        while (this.group.scrollWidth < this.viewport.clientWidth * 1.15 && passes < 8) {
          sourceItems.forEach((item) => {
            const copy = item.cloneNode(true);
            copy.dataset.logoRuntimeCopy = '';
            copy.setAttribute('aria-hidden', 'true');
            copy.querySelectorAll('a, button, input, select, textarea').forEach((control) => control.setAttribute('tabindex', '-1'));
            copy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
            this.group.appendChild(copy);
          });
          passes += 1;
        }

        const groupCopy = this.group.cloneNode(true);
        groupCopy.dataset.logoRuntimeCopy = '';
        groupCopy.classList.add('ekko-logo-list__group--clone');
        groupCopy.setAttribute('aria-hidden', 'true');
        groupCopy.querySelectorAll('a, button, input, select, textarea').forEach((control) => control.setAttribute('tabindex', '-1'));
        groupCopy.querySelectorAll('[id]').forEach((node) => node.removeAttribute('id'));
        this.track.appendChild(groupCopy);

        const gap = parseFloat(getComputedStyle(this.track).gap) || 0;
        const distance = this.group.getBoundingClientRect().width + gap;
        const speed = Math.max(10, Number(this.dataset.speed) || 50);
        this.track.style.setProperty('--ekko-logo-loop-distance', `${distance}px`);
        this.track.style.setProperty('--ekko-logo-marquee-duration', `${distance / speed}s`);
        this.viewport.dataset.ready = 'true';
      }

      move(direction) {
        this.viewport.scrollBy({ left: direction * this.viewport.clientWidth * .82, behavior: 'smooth' });
      }

      updateButtons() {
        if (!this.previousButton || !this.nextButton) return;
        const max = Math.max(0, this.viewport.scrollWidth - this.viewport.clientWidth - 2);
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= max;
      }

      onBlockSelect(event) {
        const item = event.target.closest('.shopify-block');
        if (!item || !this.group.contains(item)) return;
        if (this.viewport.dataset.mode === 'scroll') {
          const left = item.offsetLeft - (this.viewport.clientWidth - item.offsetWidth) / 2;
          this.viewport.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
        }
        if (this.viewport.dataset.mode === 'marquee') this.classList.add('is-touch-paused');
      }

      pauseForTouch(event) {
        if (this.viewport.dataset.mode !== 'marquee' || event.pointerType === 'mouse') return;
        clearTimeout(this.touchTimer);
        this.classList.add('is-touch-paused');
        this.touchTimer = setTimeout(() => this.classList.remove('is-touch-paused'), 1800);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-details"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('product-details-section')) {
    customElements.define('product-details-section', class ProductDetailsSection extends HTMLElement {
      connectedCallback() {
        this.details = [...this.querySelectorAll('.ekko-product-detail-row')];
        this.specColumnCanvas = document.createElement('canvas');
        this.specColumnContext = this.specColumnCanvas.getContext('2d');

        if (this.dataset.openFirst === 'true' && !this.details.some((item) => item.open)) {
          const firstVisible = this.details.find((item) => !item.hidden);
          if (firstVisible) firstVisible.open = true;
        }

        this.addEventListener('toggle', this.onToggle, true);
        this.addEventListener('shopify:block:select', this.onBlockSelect);

        this.specResizeObserver = new ResizeObserver(() => this.syncSpecColumns());
        this.specResizeObserver.observe(this);
        requestAnimationFrame(() => this.syncSpecColumns());
        document.fonts?.ready.then(() => {
          if (this.isConnected) this.syncSpecColumns();
        });
      }

      disconnectedCallback() {
        this.removeEventListener('toggle', this.onToggle, true);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.specResizeObserver?.disconnect();
      }

      onToggle = (event) => {
        const current = event.target;
        if (!current.matches('.ekko-product-detail-row')) return;

        if (current.open) requestAnimationFrame(() => this.syncSpecColumns(current));
        if (this.dataset.singleOpen !== 'true' || !current.open) return;

        this.details.forEach((item) => {
          if (item !== current) item.open = false;
        });
      };

      onBlockSelect = (event) => {
        const row = event.target.closest('.ekko-product-detail-row');
        if (!row) return;
        row.open = true;
        requestAnimationFrame(() => {
          this.syncSpecColumns(row);
          event.target.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      };

      syncSpecColumns = (scope = this) => {
        const tables = scope.matches?.('.ekko-product-detail-row__children')
          ? [scope]
          : [...scope.querySelectorAll('.ekko-product-detail-row__children')];

        if (!window.matchMedia('(min-width: 360px) and (max-width: 749px)').matches) {
          tables.forEach((table) => table.style.removeProperty('--ekko-pd-label-width'));
          return;
        }

        tables.forEach((table) => {
          if (!table.clientWidth || !this.specColumnContext) return;

          const labels = [...table.querySelectorAll('.ekko-product-spec-row__label')];
          let longestLabel = 0;

          labels.forEach((label) => {
            const style = getComputedStyle(label);
            this.specColumnContext.font = style.font;
            const text = label.textContent.trim();
            const letterSpacing = Number.parseFloat(style.letterSpacing) || 0;
            const measuredWidth = this.specColumnContext.measureText(text).width
              + Math.max(0, text.length - 1) * letterSpacing;
            longestLabel = Math.max(longestLabel, measuredWidth);
          });

          const maximumWidth = table.clientWidth * .4;
          const sharedWidth = Math.min(Math.ceil(longestLabel) + 1, Math.floor(maximumWidth));
          if (sharedWidth > 0) table.style.setProperty('--ekko-pd-label-width', `${sharedWidth}px`);
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slideshow-2"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('slideshow-two')) {
    class SlideshowTwo extends HTMLElement {
      connectedCallback() {
        const slidesContainer = this.querySelector('[data-slideshow-slides]');
        this.slides = slidesContainer
          ? Array.from(slidesContainer.querySelectorAll(':scope > .shopify-block > [data-slide]'))
          : [];
        if (!this.slides.length) return;

        this.index = 0;
        this.timer = null;
        this.timerDeadline = 0;
        this.timerRemaining = 0;
        this.countdownTimer = null;
        this.videoListeners = [];
        this.boundaryPaused = false;
        this.interactionPaused = false;
        this.hoverPaused = false;
        this.autoplay = this.dataset.autoplay === 'true';
        this.loop = this.dataset.loop === 'true';
        this.designMode = Boolean(window.Shopify && Shopify.designMode);
        this.pauseOnHover = this.dataset.pauseHover === 'true' && !this.designMode;
        this.defaultDuration = Number(this.dataset.autoplaySpeed || 5);
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.saveData = Boolean(navigator.connection && navigator.connection.saveData);
        this.mobileQuery = window.matchMedia('(max-width: 767px)');
        this.navigation = this.querySelector('[data-slideshow-navigation]');
        this.progress = this.querySelector('[data-progress]');
        this.currentLabel = this.querySelector('[data-current]');
        this.totalLabel = this.querySelector('[data-total]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-slide-status]');

        this.onPrevious = () => this.goTo(this.index - 1, true);
        this.onNext = () => this.goTo(this.index + 1, true);
        this.onVisibility = () => this.handleVisibility();
        this.onBlockSelect = (event) => this.handleBlockSelect(event);
        this.onPointerDown = (event) => this.handlePointerDown(event);
        this.onPointerUp = (event) => this.handlePointerUp(event);
        this.onPointerCancel = () => this.handlePointerCancel();
        this.onKeyDown = (event) => this.handleKeyDown(event);
        this.onMouseEnter = () => this.setHoverPause(true);
        this.onMouseLeave = () => this.setHoverPause(false);
        this.onMediaChange = () => this.goTo(this.index, false);
        this.onSectionReorder = () => this.refreshHeaderTransparency();

        this.querySelector('[data-previous]')?.addEventListener('click', this.onPrevious);
        this.querySelector('[data-next]')?.addEventListener('click', this.onNext);
        document.addEventListener('visibilitychange', this.onVisibility);
        document.addEventListener('shopify:section:reorder', this.onSectionReorder);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        this.addEventListener('pointerdown', this.onPointerDown, { passive: true });
        this.addEventListener('pointerup', this.onPointerUp, { passive: true });
        this.addEventListener('pointercancel', this.onPointerCancel, { passive: true });
        this.addEventListener('keydown', this.onKeyDown);
        if (this.pauseOnHover) {
          this.addEventListener('mouseenter', this.onMouseEnter);
          this.addEventListener('mouseleave', this.onMouseLeave);
        }
        this.mobileQuery.addEventListener?.('change', this.onMediaChange);

        this.buildDots();
        this.startCountdowns();
        this.navigation.hidden = this.slides.length < 2;
        this.goTo(0, false);
        this.classList.add('is-ready');
        this.refreshHeaderTransparency();
      }

      disconnectedCallback() {
        this.clearTimer();
        clearInterval(this.countdownTimer);
        document.removeEventListener('visibilitychange', this.onVisibility);
        document.removeEventListener('shopify:section:reorder', this.onSectionReorder);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
        this.removeEventListener('pointerdown', this.onPointerDown);
        this.removeEventListener('pointerup', this.onPointerUp);
        this.removeEventListener('pointercancel', this.onPointerCancel);
        this.removeEventListener('keydown', this.onKeyDown);
        this.removeEventListener('mouseenter', this.onMouseEnter);
        this.removeEventListener('mouseleave', this.onMouseLeave);
        this.mobileQuery?.removeEventListener?.('change', this.onMediaChange);
        this.clearVideoListeners();
        this.pauseVideos();
        window.requestAnimationFrame(() => this.refreshHeaderTransparency());
      }

      buildDots() {
        const dots = this.querySelector('[data-dots]');
        if (!dots) return;
        dots.replaceChildren();
        const style = dots.dataset.dotsStyle || 'dots';
        const slidesId = this.querySelector('[data-slideshow-slides]')?.id;
        this.slides.forEach((slide, index) => {
          slide.setAttribute('role', 'group');
          slide.setAttribute('aria-label', `${index + 1} / ${this.slides.length}`);
          const button = document.createElement('button');
          button.type = 'button';
          button.className = style === 'numbers' ? 'slideshow-2__number' : 'slideshow-2__dot';
          button.setAttribute('aria-label', `${this.dataset.slideLabel} ${index + 1}`);
          if (slidesId) button.setAttribute('aria-controls', slidesId);
          if (style === 'numbers') {
            button.innerHTML = `
              <svg viewBox="0 0 36 36" aria-hidden="true">
                <circle cx="18" cy="18" r="16"></circle>
                <circle class="slideshow-2__number-progress" cx="18" cy="18" r="16" pathLength="1"></circle>
              </svg>
              <span>${String(index + 1).padStart(2, '0')}</span>
            `;
          }
          button.addEventListener('click', () => this.goTo(index, true));
          dots.append(button);
        });
        this.dots = Array.from(dots.children);
      }

      normalizeIndex(index) {
        if (this.loop) return (index + this.slides.length) % this.slides.length;
        return Math.max(0, Math.min(index, this.slides.length - 1));
      }

      goTo(nextIndex, userInitiated) {
        const isInitial = !this.classList.contains('is-ready');
        const normalizedIndex = this.normalizeIndex(nextIndex);
        if (normalizedIndex !== this.index) this.boundaryPaused = false;
        this.clearTimer();
        this.clearVideoListeners();
        this.pauseVideos();
        this.index = normalizedIndex;

        this.slides.forEach((slide, index) => {
          const active = index === this.index;
          slide.classList.remove('is-entering');
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          slide.inert = !active;
        });

        const activeSlide = this.slides[this.index];
        const activeStyles = window.getComputedStyle(activeSlide);
        const controlsColor = activeStyles.getPropertyValue('--s2-slide-controls-color').trim() || '#ffffff';
        const controlsBackground = activeStyles.getPropertyValue('--s2-slide-controls-background').trim() || '#111111';
        const slideBackground = activeStyles.getPropertyValue('--s2-slide-background').trim() || '#1d1d1f';
        this.style.setProperty('--s2-controls-color', controlsColor);
        this.style.setProperty('--s2-controls-background', controlsBackground);
        this.style.setProperty('--s2-active-background', slideBackground);

        if (!isInitial) this.classList.add('has-transitioned');
        if (!isInitial || !this.classList.contains('slideshow-2--skip-initial')) {
          void activeSlide.offsetWidth;
          activeSlide.classList.add('is-entering');
        }

        this.dots?.forEach((dot, index) => dot.setAttribute('aria-current', index === this.index ? 'true' : 'false'));
        if (this.currentLabel) this.currentLabel.textContent = String(this.index + 1).padStart(2, '0');
        if (this.totalLabel) this.totalLabel.textContent = String(this.slides.length).padStart(2, '0');
        this.updateNavigationState();

        this.updatePausedState();
        this.scheduleCurrentSlide();
        if (userInitiated) this.announceCurrentSlide();
      }

      updateNavigationState() {
        const previousDisabled = !this.loop && this.index === 0;
        const nextDisabled = !this.loop && this.index === this.slides.length - 1;
        if (this.previousButton) this.previousButton.disabled = previousDisabled;
        if (this.nextButton) this.nextButton.disabled = nextDisabled;
      }

      announceCurrentSlide() {
        if (!this.status) return;
        const template = this.dataset.statusLabel || 'Slide __current__ of __total__';
        this.status.textContent = template
          .replace('__current__', String(this.index + 1))
          .replace('__total__', String(this.slides.length));
      }

      scheduleCurrentSlide() {
        const slide = this.slides[this.index];
        if (!slide) return;
        if (this.isPaused() || !this.autoplay) {
          this.resetProgress(0);
          return;
        }

        if (slide.dataset.slideType !== 'video') {
          this.scheduleNext(this.defaultDuration);
          return;
        }

        const mobilePolicy = slide.dataset.mobilePlayback || 'autoplay';
        if (this.reducedMotion || this.saveData) {
          this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
          return;
        }
        if (this.mobileQuery.matches && mobilePolicy === 'poster') {
          this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
          return;
        }

        this.playVideo(slide);
      }

      playVideo(slide) {
        const video = this.activeVideo(slide);
        if (!video) {
          this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
          return;
        }

        const mode = slide.dataset.videoAdvance || 'end';
        const restart = slide.dataset.restartVideo !== 'false';
        if (restart) video.currentTime = 0;
        video.loop = slide.dataset.videoLoop === 'true' && mode !== 'end';

        const onEnded = () => {
          if (this.slides[this.index] !== slide) return;
          if (this.slides.length < 2) return;
          if (mode === 'end' && this.autoplay && !this.isPaused()) {
            this.advance();
          }
        };
        const onError = () => {
          if (this.slides[this.index] !== slide) return;
          this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
        };
        this.bindVideoEvent(video, 'ended', onEnded, { once: true });
        this.bindVideoEvent(video, 'error', onError, { once: true });

        const playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(() => {
            if (this.slides[this.index] !== slide) return;
            this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
          });
        }

        if (!this.autoplay || this.isPaused()) return;
        if (mode === 'interval') {
          this.scheduleNext(this.defaultDuration);
        } else if (mode === 'custom') {
          this.scheduleNext(Number(slide.dataset.customDuration || this.defaultDuration));
        } else if (mode === 'end') {
          const maximum = Number(slide.dataset.maximumDuration || 0);
          const updateVideoProgress = () => {
            if (this.slides[this.index] !== slide) return;
            const remaining = Number.isFinite(video.duration) ? Math.max(.1, video.duration - video.currentTime) : 0;
            const duration = maximum > 0 && remaining > 0 ? Math.min(maximum, remaining) : (maximum || remaining);
            this.resetProgress(duration || Number(slide.dataset.fallbackDuration || this.defaultDuration));
          };
          if (video.readyState >= 1) {
            updateVideoProgress();
          } else {
            this.bindVideoEvent(video, 'loadedmetadata', updateVideoProgress, { once: true });
          }
          if (maximum > 0) this.scheduleNext(maximum, false);
        } else {
          this.resetProgress(0);
        }
      }

      bindVideoEvent(video, name, handler, options) {
        video.addEventListener(name, handler, options);
        this.videoListeners.push(() => video.removeEventListener(name, handler, options));
      }

      clearVideoListeners() {
        this.videoListeners.forEach((remove) => remove());
        this.videoListeners = [];
      }

      activeVideo(slide) {
        const preferred = this.mobileQuery.matches
          ? slide.querySelector('video.slideshow-2__media-mobile')
          : slide.querySelector('video.slideshow-2__media-desktop');
        return preferred || slide.querySelector('video');
      }

      scheduleNext(seconds, updateProgress = true) {
        if (!this.autoplay || this.isPaused() || this.slides.length < 2 || seconds <= 0) return;
        this.clearTimer();
        this.timerRemaining = seconds * 1000;
        if (updateProgress) this.resetProgress(seconds);
        this.armTimer();
      }

      clearTimer() {
        if (this.timer) window.clearTimeout(this.timer);
        this.timer = null;
        this.timerDeadline = 0;
        this.timerRemaining = 0;
      }

      armTimer() {
        if (this.timerRemaining <= 0 || this.isPaused()) return;
        this.timerDeadline = performance.now() + this.timerRemaining;
        this.timer = window.setTimeout(() => {
          this.timer = null;
          this.timerDeadline = 0;
          this.timerRemaining = 0;
          this.advance();
        }, this.timerRemaining);
      }

      pauseTimer() {
        if (!this.timer) return;
        this.timerRemaining = Math.max(0, this.timerDeadline - performance.now());
        window.clearTimeout(this.timer);
        this.timer = null;
        this.timerDeadline = 0;
      }

      resumeTimer() {
        if (this.timer || this.timerRemaining <= 0 || this.isPaused()) return;
        this.armTimer();
      }

      advance() {
        if (!this.loop && this.index === this.slides.length - 1) {
          this.boundaryPaused = true;
          this.updatePausedState();
          this.resetProgress(0);
          return;
        }
        this.goTo(this.index + 1, false);
      }

      resetProgress(seconds) {
        if (this.progress) {
          this.progress.classList.remove('is-running');
          this.progress.style.setProperty('--s2-progress-duration', `${seconds || 0}s`);
          void this.progress.offsetWidth;
          if (seconds > 0 && !this.reducedMotion) this.progress.classList.add('is-running');
        }

        this.querySelectorAll('.slideshow-2__number-progress').forEach((progress) => {
          progress.classList.remove('is-running');
          progress.style.setProperty('--s2-progress-duration', `${seconds || 0}s`);
        });
        const activeNumberProgress = this.dots?.[this.index]?.querySelector('.slideshow-2__number-progress');
        if (activeNumberProgress && seconds > 0 && !this.reducedMotion) {
          void activeNumberProgress.offsetWidth;
          activeNumberProgress.classList.add('is-running');
        }
      }

      pauseVideos() {
        this.querySelectorAll('video').forEach((video) => video.pause());
      }

      isPaused() {
        return this.boundaryPaused || this.interactionPaused || this.hoverPaused || document.hidden;
      }

      setHoverPause(paused) {
        if (!this.autoplay || this.hoverPaused === paused) return;
        this.hoverPaused = paused;

        if (paused) {
          this.pauseTimer();
          this.updatePausedState();
          return;
        }

        this.updatePausedState();
        const slide = this.slides[this.index];
        const video = slide?.dataset.slideType === 'video' ? this.activeVideo(slide) : null;
        if (video?.ended && (slide.dataset.videoAdvance || 'end') === 'end') {
          this.advance();
          return;
        }
        if (this.timerRemaining > 0) this.resumeTimer();
        if (!video || video.paused) this.resumeCurrentPlayback();
      }

      setInteractionPause(paused) {
        if (!this.autoplay || this.interactionPaused === paused) return;
        this.interactionPaused = paused;
        if (paused) {
          this.pauseCurrentPlayback();
        } else {
          this.updatePausedState();
          this.resumeCurrentPlayback();
          return;
        }
        this.updatePausedState();
      }

      pauseCurrentPlayback() {
        this.pauseTimer();
        this.activeVideo(this.slides[this.index])?.pause();
      }

      resumeCurrentPlayback() {
        if (this.isPaused() || !this.autoplay) return;
        if (this.timerRemaining > 0) this.resumeTimer();
        const slide = this.slides[this.index];
        const video = slide?.dataset.slideType === 'video' ? this.activeVideo(slide) : null;
        const mobilePolicy = slide?.dataset.mobilePlayback || 'autoplay';
        const canResumeVideo = !this.reducedMotion
          && !this.saveData
          && (!this.mobileQuery.matches || mobilePolicy === 'autoplay');
        if (video && canResumeVideo && !video.ended) {
          const playPromise = video.play();
          playPromise?.catch?.(() => {
            if (!this.timer) this.scheduleNext(Number(slide.dataset.fallbackDuration || this.defaultDuration));
          });
          return;
        }
        if (!this.timer) this.scheduleCurrentSlide();
      }

      updatePausedState() {
        this.classList.toggle('is-paused', this.isPaused());
      }

      handleVisibility() {
        if (document.hidden) {
          this.pauseCurrentPlayback();
          this.updatePausedState();
        } else {
          this.updatePausedState();
          this.resumeCurrentPlayback();
        }
      }

      handleBlockSelect(event) {
        const slide = event.target.matches?.('[data-slide]')
          ? event.target
          : event.target.querySelector?.(':scope > [data-slide]') || event.target.closest?.('[data-slide]');
        const index = this.slides.indexOf(slide);
        if (index >= 0) this.goTo(index, false);
      }

      handlePointerDown(event) {
        if (event.pointerType === 'mouse') return;
        this.pointerStart = event.clientX;
        this.pointerStartY = event.clientY;
        this.setInteractionPause(true);
      }

      handlePointerUp(event) {
        if (this.pointerStart == null) return;
        const distanceX = event.clientX - this.pointerStart;
        const distanceY = event.clientY - this.pointerStartY;
        this.pointerStart = null;
        this.pointerStartY = null;
        if (Math.abs(distanceX) > 45 && Math.abs(distanceX) > Math.abs(distanceY) * 1.25) {
          this.goTo(this.index + (distanceX < 0 ? 1 : -1), true);
        }
        this.setInteractionPause(false);
      }

      handlePointerCancel() {
        this.pointerStart = null;
        this.pointerStartY = null;
        this.setInteractionPause(false);
      }

      handleKeyDown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.goTo(this.index - 1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.goTo(this.index + 1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.slides.length - 1, true);
        }
      }

      refreshHeaderTransparency() {
        window.requestAnimationFrame(() => {
          const header = document.querySelector('.header[is="custom-header"], .header[is="sticky-header"]');
          if (header && typeof header.init === 'function') header.init();
        });
      }

      startCountdowns() {
        const update = () => {
          this.querySelectorAll('[data-countdown]').forEach((countdown) => this.updateCountdown(countdown));
        };
        update();
        this.countdownTimer = window.setInterval(update, 1000);
      }

      updateCountdown(countdown) {
        const date = countdown.dataset.date;
        if (!date) return;
        const time = countdown.dataset.time || '00:00';
        const zone = countdown.dataset.timezone === 'Z' ? 'Z' : (countdown.dataset.timezone || 'Z');
        const target = Date.parse(`${date}T${time}:00${zone}`);
        if (!Number.isFinite(target)) return;
        const remaining = Math.max(0, target - Date.now());
        const values = {
          days: Math.floor(remaining / 86400000),
          hours: Math.floor((remaining / 3600000) % 24),
          minutes: Math.floor((remaining / 60000) % 60),
          seconds: Math.floor((remaining / 1000) % 60)
        };
        Object.entries(values).forEach(([key, value]) => {
          const node = countdown.querySelector(`[data-countdown-${key}]`);
          if (node) node.textContent = String(value).padStart(2, '0');
        });
        if (remaining === 0) {
          if (countdown.dataset.expiredBehavior === 'hide') countdown.hidden = true;
          if (countdown.dataset.expiredBehavior === 'message') {
            countdown.querySelector('[data-countdown-values]')?.setAttribute('hidden', '');
            countdown.querySelector('[data-countdown-expired]')?.removeAttribute('hidden');
          }
        }
      }
    }

    customElements.define('slideshow-two', SlideshowTwo);
  }

  } catch(e) { console.error(e); }
})();
})();
